'use client';

import { ModalContainer, ModalRoot } from '@mentimeter/ragnar-ui/modal';
import {
  useCloseModalPaywall,
  useActivePaywallModal,
} from '../hooks/use-modal-paywall';

export function PaywallsModal() {
  const { open, activePaywallModalContent } = useActivePaywallModal();

  return <ModalRoot open={open}>{activePaywallModalContent}</ModalRoot>;
}

interface PaywallModalContainerProps
  extends React.ComponentProps<typeof ModalContainer> {
  children: React.ReactNode;
}

export function PaywallModalContainer({
  ...props
}: PaywallModalContainerProps) {
  const closePaywallModal = useCloseModalPaywall();

  return (
    <ModalContainer
      onInteractOutside={closePaywallModal}
      onEscapeKeyDown={closePaywallModal}
      {...props}
    />
  );
}
